import { Reactive1jy75v4li6ldv as Reactive } from '../../../../../reactive/com/lightningkite/reactive/core/coreInterfaces.mjs';
import { initMetadataForInterface1egvbzx539z91 as initMetadataForInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var LimitReactiveListClass;
function LimitReactiveList() {
  if (LimitReactiveListClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'LimitReactiveList', VOID, VOID, [Reactive()], [1]);
    LimitReactiveListClass = $;
  }
  return LimitReactiveListClass;
}
//region block: exports
export {
  LimitReactiveList as LimitReactiveList3fo42zjtyuog7,
};
//endregion

//# sourceMappingURL=LimitReactiveList.mjs.map
